export const multiLang = ["en", "kn"]